module.exports = __webpack_public_path__ + "img/imgData.1ba80abd.png";